import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Products from "./components/Products";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const App = () => {
  return (
    <>
      <Header />
      <Hero />

      <div style={{ background: "#f9f9f9", padding: "10px" }}>
        <Services />
        <Products />
      </div>
      <Contact />
      <Footer />
    </>
  );
};

export default App;
